// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2racG","dragIcon":"Choice_dragIcon__d01a-","left":"Choice_left__3Eluo","input":"Choice_input__D0c9g"};